import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 130 116",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M114 114H16C8.26801 114 2 107.732 2 100L2 16C2 8.26801 8.26802 2 16 2L86 2C93.732 2 100 8.26801 100 16V23M114 114C106.268 114 100 107.732 100 100L100 23M114 114C121.732 114 128 107.732 128 100V37C128 29.268 121.732 23 114 23L100 23M72 2L44 2M30 86H72M30 30H72V58H30V30Z",
      stroke: "currentColor",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }